export default "__VITE_ASSET__B2nTvxzn__"